import React from 'react';
import { Glass } from 'iconsax-react';


const Rentals = () => {
  return <div>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g id="vuesax_bold_glass" data-name="vuesax/bold/glass" transform="translate(-364 -508)">
          <g id="glass">
            <path id="Vector" d="M15.95,0H15a.715.715,0,0,0,0,1.43h.95a3.1,3.1,0,0,1,3.1,3.09V10.4a2.523,2.523,0,0,0-1.19-.29H14.05a2.623,2.623,0,0,0-2.62,2.62v1.56H9.05V12.73a2.623,2.623,0,0,0-2.62-2.62H2.62a2.523,2.523,0,0,0-1.19.29V4.52a3.1,3.1,0,0,1,3.1-3.09h.95A.715.715,0,0,0,5.48,0H4.53A4.53,4.53,0,0,0,0,4.52V17.38A2.623,2.623,0,0,0,2.62,20H6.43a2.623,2.623,0,0,0,2.62-2.62V15.71h2.38v1.67A2.623,2.623,0,0,0,14.05,20h3.81a2.623,2.623,0,0,0,2.62-2.62V4.52A4.53,4.53,0,0,0,15.95,0Z" transform="translate(365.76 510)" fill="#fff"/>
            <path id="Vector-2" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(388 532) rotate(180)" fill="none" opacity="0"/>
          </g>
        </g>
      </svg>

  </div>;
};

export default Rentals;
